const FirebaseConfig = {
  apiKey: "AIzaSyDPWnTylq4I0pJYoUK_zAoSBzysPppq8WM",
  authDomain: "regiamobil-257a5.firebaseapp.com",
  projectId: "regiamobil-257a5",
  storageBucket: "regiamobil-257a5.appspot.com",
  messagingSenderId: "876174160870",
  appId: "1:876174160870:web:245fee736715a4e0fd5c27",
  measurementId: "G-5GBER4T3CY"
};

export default FirebaseConfig

